import {
	AppstoreOutlined,
	MailOutlined,
	DesktopOutlined,
	UsergroupAddOutlined,
	UserSwitchOutlined,
	StarOutlined,
	UserOutlined,
	MenuOutlined,
	EnvironmentOutlined,
	EditOutlined,
	ShopOutlined,
	SolutionOutlined,
	CreditCardOutlined,
	NotificationOutlined,
	CustomerServiceOutlined,
	SearchOutlined,
	TagOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export const appsNavTree = [
	{
		key: 'apps-project',
		path: `${APP_PREFIX_PATH}/dashboards`,
		title: 'Dashboard',
		icon: AppstoreOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'users',
				path: `${APP_PREFIX_PATH}/dashboards/default`,
				title: 'Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'Products',
				path: `${APP_PREFIX_PATH}/dashboards/products`,
				title: 'Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'Jobs',
				path: `${APP_PREFIX_PATH}/dashboards/jobs`,
				title: 'Jobs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'Services',
				path: `${APP_PREFIX_PATH}/dashboards/services`,
				title: 'Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'branch-performance',
			// 	path: `${APP_PREFIX_PATH}/dashboards/branch-performance`,
			// 	title: 'Branch Performance',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'sales-advisor-performance',
			// 	path: `${APP_PREFIX_PATH}/dashboards/sales-advisor-performance`,
			// 	title: 'Sales Advisor Performance',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'Sales-advisor-activity-logs',
			// 	path: `${APP_PREFIX_PATH}/dashboards/sales-advisor-activity-logs`,
			// 	title: 'Sales Advisor Activity Logs',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'service-advisor-activity-logs',
			// 	path: `${APP_PREFIX_PATH}/dashboards/service-advisors-activity-logs`,
			// 	title: 'Service Advisor Activity Logs',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	{
		key: 'user-management',
		path: `${APP_PREFIX_PATH}/user-management`,
		title: 'User Management',
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'all-users',
				path: `${APP_PREFIX_PATH}/user-management/all-users`,
				title: 'All Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'reported-users',
				path: `${APP_PREFIX_PATH}/user-management/reported-users`,
				title: 'Reported Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'blocked-users',
				path: `${APP_PREFIX_PATH}/user-management/blocked-users`,
				title: 'Blocked Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},


	// {
	// 	key: 'chat-management',
	// 	path: `${APP_PREFIX_PATH}/chat-management`,
	// 	title: 'Chat Management',
	// 	icon: MessageOutlined,
	// 	breadcrumb: false,
	// 	submenu: [],
	// },
	{
		key: 'product-management',
		path: `${APP_PREFIX_PATH}/product-management`,
		title: 'Product Management',
		icon: ShopOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'all-products',
				path: `${APP_PREFIX_PATH}/product-management/all`,
				title: 'All Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'faildTranslation',
				path: `${APP_PREFIX_PATH}/product-management/faild-translation`,
				title: 'Failed Translation',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'reported-products',
				path: `${APP_PREFIX_PATH}/product-management/reported`,
				title: 'Reported Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'blocked-products',
				path: `${APP_PREFIX_PATH}/product-management/blocked`,
				title: 'Blocked Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'appealed-products',
				path: `${APP_PREFIX_PATH}/product-management/appealed`,
				title: 'Appealed Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'service-management',
		path: `${APP_PREFIX_PATH}/service-management`,
		title: 'Service Management',
		icon: ShopOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'all-services',
				path: `${APP_PREFIX_PATH}/service-management/all`,
				title: 'All Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'reported-services',
				path: `${APP_PREFIX_PATH}/service-management/reported`,
				title: 'Reported Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'blocked-services',
				path: `${APP_PREFIX_PATH}/service-management/blocked`,
				title: 'Blocked Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'appealed-services',
				path: `${APP_PREFIX_PATH}/service-management/appealed`,
				title: 'Appealed Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'job-management',
		path: `${APP_PREFIX_PATH}/job-management`,
		title: 'Job Management',
		icon: SolutionOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'all-jobs',
				path: `${APP_PREFIX_PATH}/job-management/all`,
				title: 'All jobs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'blocked-jobs',
				path: `${APP_PREFIX_PATH}/job-management/blocked`,
				title: 'Blocked jobs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'pending-jobs',
			// 	path: `${APP_PREFIX_PATH}/job-management/pending`,
			// 	title: 'Pending jobs',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'reported-jobs',
				path: `${APP_PREFIX_PATH}/job-management/reported`,
				title: 'Reported jobs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'search-query',
		path: `${APP_PREFIX_PATH}/search-query`,
		title: 'Search Data Info',
		icon: SearchOutlined,
		breadcrumb: false,
		submenu: [{
			key: 'search-query',
			path: `${APP_PREFIX_PATH}/search-query`,
			title: 'Search Query',
			icon: SearchOutlined,
			breadcrumb: false,
			submenu: [],
		},
		{
			key: 'search-trends',
			path: `${APP_PREFIX_PATH}/search-trends`,
			title: 'Search Trends	',
			icon: SearchOutlined,
			breadcrumb: false,
			submenu: [],
		}],
	},
	{
		key: 'category-management',
		path: `${APP_PREFIX_PATH}/category-management`,
		title: 'Category Management',
		icon: MenuOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'products',
				path: `${APP_PREFIX_PATH}/category-management/products`,
				title: 'Products',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'services',
				path: `${APP_PREFIX_PATH}/category-management/services`,
				title: 'Services',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'jobs',
				path: `${APP_PREFIX_PATH}/category-management/jobs`,
				title: 'Jobs',
				icon: '',
				breadcrumb: false,
				submenu: [
					{
						key: 'jobs-category',
						path: `${APP_PREFIX_PATH}/category-management/jobs`,
						title: 'Category',
						icon: '',
						breadcrumb: false,
						submenu: [],
					},
					{
						key: 'jobs-category-fields',
						path: `${APP_PREFIX_PATH}/category-management/jobs/dynamic-fields`,
						title: 'Dynamic Fields',
						icon: '',
						breadcrumb: false,
						submenu: [],
					},
				],
			},
		],
	},
	{
		key: 'ads-management',
		path: `${APP_PREFIX_PATH}/ads-management`,
		title: 'Ads Management',
		icon: NotificationOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'default',
				path: `${APP_PREFIX_PATH}/ads-management/default`,
				title: 'Default Ad banners',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'scheduled',
				path: `${APP_PREFIX_PATH}/ads-management/scheduled`,
				title: 'Scheduled Ad Banner',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'ads-leads',
				path: `${APP_PREFIX_PATH}/ads-management/ads-leads`,
				title: 'Ads Banner Leads',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'coupon-management',
		path: `${APP_PREFIX_PATH}/coupon-management`,
		title: 'Coupons Management',
		icon: TagOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'generate',
				path: `${APP_PREFIX_PATH}/coupon-management/generate`,
				title: 'Generate Coupon',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'redeem-coupons',
				path: `${APP_PREFIX_PATH}/coupon-management/redeem-coupons`,
				title: 'Redeem Coupons',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'active-expire',
			// 	path: `${APP_PREFIX_PATH}/coupon-management/active-expire`,
			// 	title: 'Active & Expired Ads',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	{
		key: 'subscription',
		path: `${APP_PREFIX_PATH}/subscription`,
		title: 'Subscription',
		icon: CreditCardOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'feature-plans',
				path: `${APP_PREFIX_PATH}/subscription/feature-plans`,
				title: 'Feature & Plans',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'unlimited-listings',
				path: `${APP_PREFIX_PATH}/subscription/unlimited-listings`,
				title: 'Unlimited Listings',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bumpup-listing',
				path: `${APP_PREFIX_PATH}/subscription/bumpup-listing`,
				title: 'Bump up Listings',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'loffre-premium',
			// 	path: `${APP_PREFIX_PATH}/subscription/loffre-premium`,
			// 	title: 'Loffre Premium',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'featured-listings',
				path: `${APP_PREFIX_PATH}/subscription/featured-listings`,
				title: 'Feature Listings',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'coupon-management',
			// 	path: `${APP_PREFIX_PATH}/subscription/coupon-management`,
			// 	title: 'Coupon Management',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'subscribed-users',
				path: `${APP_PREFIX_PATH}/subscription/subscribed-users`,
				title: 'Subscribe Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'expired-subscription',
				path: `${APP_PREFIX_PATH}/subscription/expired-subscription`,
				title: 'Expired Subscription',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'meetup-location',
		path: `${APP_PREFIX_PATH}/meetup-location`,
		title: 'Meetup Location',
		icon: EnvironmentOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'meetup-location-active',
				path: `${APP_PREFIX_PATH}/meetup-location/active`,
				title: 'Manage Active Location',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'meetup-location-pending',
			// 	path: `${APP_PREFIX_PATH}/meetup-location/pending`,
			// 	title: 'Manage Pending Location',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	{
		key: 'feedback-reviews',
		path: `${APP_PREFIX_PATH}/feedback-reviews`,
		title: 'Feedback & Reviews',
		icon: EditOutlined,
		breadcrumb: false,
		submenu: [{
			key: 'product-feedback',
			path: `${APP_PREFIX_PATH}/feedback-reviews/product`,
			title: 'Product Feedback',
			icon: '',
			breadcrumb: false,
			submenu: [],
		},
		{
			key: 'service-feedback',
			path: `${APP_PREFIX_PATH}/feedback-reviews/service`,
			title: 'Service Feedback',
			icon: '',
			breadcrumb: false,
			submenu: [],
		},],
	},
	{
		key: 'help-center',
		path: `${APP_PREFIX_PATH}/help-center`,
		title: 'Help Center',
		icon: CustomerServiceOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'parent',
				path: `${APP_PREFIX_PATH}/help-center/parent`,
				title: 'Article Category',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'article',
				path: `${APP_PREFIX_PATH}/help-center/article`,
				title: 'Article',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	}
];

export const branchManagerNavTree = [
	{
		key: 'bm-dashboards',
		path: `${APP_PREFIX_PATH}/dashboards`,
		title: 'Dashboards',
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'bm-dashboards',
				path: `${APP_PREFIX_PATH}/branch-manager/dashboard`,
				title: 'Dashboards',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-branch-performance',
				path: `${APP_PREFIX_PATH}/branch-manager/branch-performance`,
				title: 'Branch Performance',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-sales-advisor-performance',
				path: `${APP_PREFIX_PATH}/branch-manager/sales-advisor-performance`,
				title: 'Sales Advisor Performance',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-Sales-advisor-activity-logs',
				path: `${APP_PREFIX_PATH}/branch-manager/sales-advisor-activity-logs`,
				title: 'Sales Advisor Activity Logs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-service-advisor-activity-logs',
				path: `${APP_PREFIX_PATH}/branch-manager/service-advisors-activity-logs`,
				title: 'Service Advisor Activity Logs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'bm-team-member',
		path: `${APP_PREFIX_PATH}/branch-manager/team-members`,
		title: 'Team Members',
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [
			// {
			// 	key: 'bm-team-members',
			// 	path: `${APP_PREFIX_PATH}/branch-manager/team-members`,
			// 	title: 'Team Members',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'bm-branch-manager',
			// 	path: `${APP_PREFIX_PATH}/branch-manager/branch-manager`,
			// 	title: 'Branch Manager',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'bm-sales-advisers',
				path: `${APP_PREFIX_PATH}/branch-manager/sales-advisers-team`,
				title: 'Sales Advisers',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-service-advisers',
				path: `${APP_PREFIX_PATH}/branch-manager/service-advisers-team`,
				title: 'Service Advisers',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'bm-leads-management',
		path: `${APP_PREFIX_PATH}/branch-manager/leads-management`,
		title: 'Leads Management',
		icon: MailOutlined,
		breadcrumb: false,
		submenu: [
			// {
			// 	key: 'bm-leads-management',
			// 	path: `${APP_PREFIX_PATH}/branch-manager/leads-management`,
			// 	title: 'Leads Management',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'bm-add-lead-source-status',
			// 	path: `${APP_PREFIX_PATH}/branch-manager/add-lead-source-status`,
			// 	title: 'Add Lead Source & Status',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	{
		key: 'bm-profile-under-review',
		path: `${APP_PREFIX_PATH}/branch-manager/profile-under-review`,
		title: 'Profile Under Review',
		icon: UserSwitchOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: 'bm-subscriptions',
		path: `${APP_PREFIX_PATH}/branch-manager/subscriptions`,
		title: 'Subscriptions',
		icon: StarOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'bm-subscription-plans',
				path: `${APP_PREFIX_PATH}/branch-manager/subscriptions/subscription-plans`,
				title: 'Subscription Plans',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-subscribed-users',
				path: `${APP_PREFIX_PATH}/branch-manager/subscriptions/subscribed-users`,
				title: 'Subscribed Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-expired-subscription-users',
				path: `${APP_PREFIX_PATH}/branch-manager/subscriptions/expired-subscription-users`,
				title: 'Expired Subscription Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'bm-app-users',
		path: `${APP_PREFIX_PATH}/branch-manager/app-users`,
		title: 'App Users',
		icon: DesktopOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'bm-registered-users',
				path: `${APP_PREFIX_PATH}/branch-manager/app-users/registered-users`,
				title: 'Registered Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-drafted-profile-users',
				path: `${APP_PREFIX_PATH}/branch-manager/app-users/drafted-profile-users`,
				title: 'Drafted Profile Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-brides',
				path: `${APP_PREFIX_PATH}/branch-manager/app-users/brides`,
				title: 'Brides',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'bm-grooms',
				path: `${APP_PREFIX_PATH}/branch-manager/app-users/grooms`,
				title: 'Grooms',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
];

export const salesAdvisorNavTree = [
	{
		key: 'sm-dashboards',
		path: `${APP_PREFIX_PATH}/sales-advisor/dashboards`,
		title: 'Dashboards',
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sa-dashboards',
				path: `${APP_PREFIX_PATH}/sales-advisor/dashboard`,
				title: 'Dashboards',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'sa-branch-performance',
			// 	path: `${APP_PREFIX_PATH}/sales-advisor/branch-performance`,
			// 	title: 'Branch Performance',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'sa-sales-advisor-performance',
				path: `${APP_PREFIX_PATH}/sales-advisor/sales-advisor-performance`,
				title: 'Sales Advisor Performance',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-Sales-advisor-activity-logs',
				path: `${APP_PREFIX_PATH}/sales-advisor/sales-advisor-activity-logs`,
				title: 'Sales Advisor Activity Logs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'sa-service-advisor-activity-logs',
			// 	path: `${APP_PREFIX_PATH}/sales-advisor/service-advisors-activity-logs`,
			// 	title: 'Service Advisor Activity Logs',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	// {
	// 	key: 'sa-team-member',
	// 	path: `${APP_PREFIX_PATH}/sales-advisor/team-members`,
	// 	title: 'Team Members',
	// 	icon: UsergroupAddOutlined,
	// 	breadcrumb: false,
	// 	submenu: [
	// 		{
	// 			key: 'sa-team-members',
	// 			path: `${APP_PREFIX_PATH}/sales-advisor/team-members`,
	// 			title: 'Team Members',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sa-branch-manager',
	// 			path: `${APP_PREFIX_PATH}/sales-advisor/branch-manager`,
	// 			title: 'Branch Manager',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sa-sales-advisers',
	// 			path: `${APP_PREFIX_PATH}/sales-advisor/sales-advisers-team`,
	// 			title: 'Sales Advisers',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sa-service-advisers',
	// 			path: `${APP_PREFIX_PATH}/sales-advisor/service-advisers-team`,
	// 			title: 'Service Advisers',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 	],
	// },
	{
		key: 'sa-leads-management',
		path: `${APP_PREFIX_PATH}/sales-advisor/leads-management`,
		title: 'Leads Management',
		icon: MailOutlined,
		breadcrumb: false,
		submenu: [
			// {
			// 	key: 'sa-leads-management',
			// 	path: `${APP_PREFIX_PATH}/sales-advisor/leads-management`,
			// 	title: 'Leads Management',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'sa-add-lead-source-status',
			// 	path: `${APP_PREFIX_PATH}/sales-advisor/add-lead-source-status`,
			// 	title: 'Add Lead Source & Status',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
		],
	},
	{
		key: 'sa-subscriptions',
		path: `${APP_PREFIX_PATH}/sales-advisor/subscriptions`,
		title: 'Subscriptions',
		icon: StarOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sa-subscription-plans',
				path: `${APP_PREFIX_PATH}/sales-advisor/subscriptions/subscription-plans`,
				title: 'Subscription Plans',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-subscribed-users',
				path: `${APP_PREFIX_PATH}/sales-advisor/subscriptions/subscribed-users`,
				title: 'Subscribed Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-expired-subscription-users',
				path: `${APP_PREFIX_PATH}/sales-advisor/subscriptions/expired-subscription-users`,
				title: 'Expired Subscription Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'sa-app-users',
		path: `${APP_PREFIX_PATH}/sales-advisor/app-users`,
		title: 'App Users',
		icon: DesktopOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sa-registered-users',
				path: `${APP_PREFIX_PATH}/sales-advisor/app-users/registered-users`,
				title: 'Registered Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-drafted-profile-users',
				path: `${APP_PREFIX_PATH}/sales-advisor/app-users/drafted-profile-users`,
				title: 'Drafted Profile Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-brides',
				path: `${APP_PREFIX_PATH}/sales-advisor/app-users/brides`,
				title: 'Brides',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sa-grooms',
				path: `${APP_PREFIX_PATH}/sales-advisor/app-users/grooms`,
				title: 'Grooms',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	// {
	// 	key: 'sa-user-details',
	// 	path: `${APP_PREFIX_PATH}/sales-advisor/user-details`,
	// 	title: 'User Details',
	// 	icon: UserSwitchOutlined,
	// 	breadcrumb: false,
	// 	submenu: [],
	// },
	// {
	// 	key: 'sa-user-details-preview',
	// 	path: `${APP_PREFIX_PATH}/sales-advisor/user-details-preview`,
	// 	title: 'User Details Preview',
	// 	icon: UserSwitchOutlined,
	// 	breadcrumb: false,
	// 	submenu: [],
	// },
];

export const serviceAdvisorNavTree = [
	{
		key: 'smp-dashboards',
		path: `${APP_PREFIX_PATH}/service-advisor/dashboards`,
		title: 'Dashboard',
		icon: AppstoreOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sap-dashboards',
				path: `${APP_PREFIX_PATH}/service-advisor/dashboard`,
				title: 'Dashboard',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			// {
			// 	key: 'sap-branch-performance',
			// 	path: `${APP_PREFIX_PATH}/service-advisor/branch-performance`,
			// 	title: 'Branch Performance',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'sap-sales-advisor-performance',
			// 	path: `${APP_PREFIX_PATH}/service-advisor/sales-advisor-performance`,
			// 	title: 'Sales Advisor Performance',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			// {
			// 	key: 'sap-Sales-advisor-activity-logs',
			// 	path: `${APP_PREFIX_PATH}/service-advisor/sales-advisor-activity-logs`,
			// 	title: 'Sales Advisor Activity Logs',
			// 	icon: '',
			// 	breadcrumb: false,
			// 	submenu: [],
			// },
			{
				key: 'sap-service-advisor-activity-logs',
				path: `${APP_PREFIX_PATH}/service-advisor/service-advisors-activity-logs`,
				title: 'Service Advisor Activity Logs',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'sap-profile-sharing',
		path: `${APP_PREFIX_PATH}/service-advisor/profile-sharing`,
		title: 'Profile Sharing',
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sap-candidate-profile',
				path: `${APP_PREFIX_PATH}/service-advisor/candidate-profile`,
				title: 'Candidate Profile',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-shared-viewed-profile',
				path: `${APP_PREFIX_PATH}/service-advisor/shared-viewed-profile`,
				title: 'Shared & Viewed Profile',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-shared-profile-details',
				path: `${APP_PREFIX_PATH}/service-advisor/shared-profile-details`,
				title: 'Shared Profile Details',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-viewed-profile-details',
				path: `${APP_PREFIX_PATH}/service-advisor/viewed-profile-details`,
				title: 'Viewed Profile Details',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	// {
	// 	key: 'sap-team-member',
	// 	path: `${APP_PREFIX_PATH}/service-advisor/team-members`,
	// 	title: 'Team Members',
	// 	icon: UsergroupAddOutlined,
	// 	breadcrumb: false,
	// 	submenu: [
	// 		{
	// 			key: 'sap-team-members',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/team-members`,
	// 			title: 'Team Members',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sap-branch-manager',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/branch-manager`,
	// 			title: 'Branch Manager',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sap-sales-advisers',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/sales-advisers-team`,
	// 			title: 'Sales Advisers',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sap-service-advisers',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/service-advisers-team`,
	// 			title: 'Service Advisers',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 	],
	// },
	// {
	// 	key: 'sap-leads-management',
	// 	path: `${APP_PREFIX_PATH}/service-advisor/leads-management`,
	// 	title: 'Leads Management',
	// 	icon: MailOutlined,
	// 	breadcrumb: false,
	// 	submenu: [
	// 		{
	// 			key: 'sap-leads-management',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/leads-management`,
	// 			title: 'Leads Management',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 		{
	// 			key: 'sap-add-lead-source-status',
	// 			path: `${APP_PREFIX_PATH}/service-advisor/add-lead-source-status`,
	// 			title: 'Add Lead Source & Status',
	// 			icon: '',
	// 			breadcrumb: false,
	// 			submenu: [],
	// 		},
	// 	],
	// },
	{
		key: 'sap-subscriptions',
		path: `${APP_PREFIX_PATH}/service-advisor/subscriptions`,
		title: 'Subscriptions',
		icon: StarOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sap-subscription-plans',
				path: `${APP_PREFIX_PATH}/service-advisor/subscriptions/subscription-plans`,
				title: 'Subscription Plans',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-subscribed-users',
				path: `${APP_PREFIX_PATH}/service-advisor/subscriptions/subscribed-users`,
				title: 'Subscribed Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-expired-subscription-users',
				path: `${APP_PREFIX_PATH}/service-advisor/subscriptions/expired-subscription-users`,
				title: 'Expired Subscription Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
	{
		key: 'sap-app-users',
		path: `${APP_PREFIX_PATH}/service-advisor/app-users`,
		title: 'App Users',
		icon: DesktopOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: 'sap-registered-users',
				path: `${APP_PREFIX_PATH}/service-advisor/app-users/registered-users`,
				title: 'Registered Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-drafted-profile-users',
				path: `${APP_PREFIX_PATH}/service-advisor/app-users/drafted-profile-users`,
				title: 'Drafted Profile Users',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-brides',
				path: `${APP_PREFIX_PATH}/service-advisor/app-users/brides`,
				title: 'Brides',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
			{
				key: 'sap-grooms',
				path: `${APP_PREFIX_PATH}/service-advisor/app-users/grooms`,
				title: 'Grooms',
				icon: '',
				breadcrumb: false,
				submenu: [],
			},
		],
	},
];

const navigationConfig = [];

// switch (localStorage.getItem('user_type')) {
// 	case 'superadmin':
// 		navigationConfig = [...appsNavTree];
// 		break;
// 	case 'branch_manager':
// 		navigationConfig = [...branchManagerNavTree];
// 		break;
// 	// case 'sales_advisor':
// 	// 	navigationConfig = salesAdvisorNavTree;
// 	// 	break;
// 	// case 'service_advisor':
// 	// 	navigationConfig = serviceAdvisorNavTree;
// 	// 	break;
// 	// default:
// 	// 	navigationConfig = adminNavTree;
// 	// 	break;
// }

export default navigationConfig;
